import React,{useState} from 'react';
import PropTypes from 'prop-types';
import {PdfGenerator} from '../components/PdfGenerator';

const RegistrationCompleted = ({ 
  primaryColor = '#1F3047',
  secondaryColor = '#349AC8',
  successColor = '#34C88D',
  textColor = '#1F3047',
  onPrint = () => {},
  onFinish = () => {}
}) => {
  const formData = JSON.parse(window.localStorage.getItem('formData'));
  const signatureData = window.localStorage.getItem('signatureData');
  const staffSignatureData = window.localStorage.getItem('staffSignatureData');
  const [isLoading, setIsLoading] = useState(false);

  const handlePrint = async () => {
    console.log("handleprint");
    
    try {
      // Show loader
      setIsLoading(true);
      
      const { pdfUrl } = await PdfGenerator(
        formData,
        signatureData,
        staffSignatureData,
        null,
        { download: true }
      );
      
      console.log("PDF generated successfully:", pdfUrl);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      // Hide loader whether successful or failed
      setIsLoading(false);
    }
  }

  return (
    <div style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: '64px',
      padding: '20px',
      maxWidth: '800px',
      margin: '0 auto'
    }}>
      {/* Success Animation and Title */}
      <div style={{
        alignSelf: 'stretch',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '48px'
      }}>
        {/* Animated Checkmark */}
        <div style={{
        //   padding: '128px 90px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '10px',
          position: 'relative'
        }}>
          {/* Circle */}
          <div style={{
            width: '261.63px',
            height: '261.63px',
            borderRadius: '50%',
            border: `8px solid ${successColor}`,
            position: 'relative'
          }}>
            {/* Checkmark */}
            <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: successColor,
              fontSize: '120px',
              fontFamily: 'Turbinado Pro, sans-serif',
              fontWeight: '400',
              lineHeight: '24px'
            }}>
              ✓
            </div>
          </div>
          
          {/* Optional: Animated lines (commented out as they may not be necessary) */}
{/*           
          {[...Array(16)].map((_, i) => (
            <div key={i} style={{
              width: i === 0 ? '58.02px' : '33.34px',
              height: '17.78px',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: `rotate(${i * 22.5}deg)`,
              transformOrigin: 'left center',
              background: successColor,
              zIndex: -1
            }} />
          ))}
          */}
        </div>
        
        {/* Title */}
        <h1 style={{
          alignSelf: 'stretch',
          textAlign: 'center',
          color: primaryColor,
          fontSize: '32px',
          fontFamily: 'Mauren, sans-serif',
          fontWeight: '100',
          margin: 0
        }}>
          Registration Completed
        </h1>
      </div>

      {/* Success Message */}
      <div style={{
        alignSelf: 'stretch',
        textAlign: 'center',
        color: textColor,
        fontSize: '16px',
        fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
        fontWeight: '400',
        lineHeight: '24px'
      }}>
        Your intake form has been successfully completed and signed.<br />
        A copy of this signed document has been securely recorded.
      </div>

      {/* Action Buttons */}
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px'
      }}>
        {/* Print Button */}
        <button 
          onClick={handlePrint}
          style={{
            padding: '12px 16px',
            borderRadius: '16px',
            outline: `1px solid ${secondaryColor}`,
            border: 'none',
            background: 'transparent',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            cursor: 'pointer'
          }}
        >
<div style={{
  width: '24px',
  height: '24px',
  background: secondaryColor,
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  transition: 'all 0.2s ease',
  ':hover': {
    transform: 'scale(1.1)'
  }
}}>
  {/* Download icon using SVG for perfect rendering */}
  <svg 
    width="12" 
    height="12" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="white" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
</div>
          <span style={{
            color: primaryColor,
            fontSize: '16px',
            fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
            fontWeight: '400'
          }}>
            Download PDF
          </span>
        </button>
        
        {/* Finish Button */}
        <button 
          onClick={onFinish}
          style={{
            padding: '12px 16px',
            background: secondaryColor,
            borderRadius: '16px',
            border: 'none',
            color: 'white',
            fontSize: '16px',
            fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
            fontWeight: '400',
            cursor: 'pointer'
          }}
        >
          Finish
        </button>
      </div>
      {isLoading && (
  <div className="loader-overlay">
    <div className="loader-spinner"></div>
    <p>Generating PDF...</p>
  </div>
)}
    </div>
  );
};

// PropTypes
RegistrationCompleted.propTypes = {
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  successColor: PropTypes.string,
  textColor: PropTypes.string,
  onPrint: PropTypes.func,
  onFinish: PropTypes.func
};

export default RegistrationCompleted;